export default __webpack_public_path__ + "static/media/Bryn-Kenney.a7d7f033.png";